export interface Quote {
    id: number;
    name: string;
    creationDate: Date;
    state: QuoteState;
    quoteItems: QuoteItem[];
    request: QuoteRequest;
}

export interface QuoteItem {
    quantity: number;
    productId: number;
}

export enum QuoteState {
    NEW = 'NEW',
    REQUESTED = 'REQUESTED',
    ORDERED = 'ORDERED'
}

export interface QuoteRequest {
    address: Address;
    generatedRequestId: string;
    requestDate: Date;
}

export interface Address {
    firstName: string;
    lastName: string;
    company: string;
    street: string;
    zipCode: string;
    city: string;
    countryId: string;
    vat: string;
}

export class QuoteConstants {
    public static readonly DECOR_DEFAULT_NAME = 'Additional Decor';
    public static readonly NAME_MIN_LENGTH = 4;
    public static readonly NAME_MAX_LENGTH = 64;
    public static readonly PRODUCT_QUANTITY_MIN_VALUE = 1;
    public static readonly PRODUCT_QUANTITY_MAX_VALUE = 999;
    public static readonly ADDRESS_FIRST_NAME_MAX_LENGTH = 255;
    public static readonly ADDRESS_LAST_NAME_MAX_LENGTH = 255;
    public static readonly ADDRESS_COMPANY_MAX_LENGTH = 255;
    public static readonly ADDRESS_ZIP_CODE_MAX_LENGTH = 16;
    public static readonly ADDRESS_CITY_MAX_LENGTH = 255;
    public static readonly ADDRESS_VAT_MAX_LENGTH = 50;
}
